import * as types from './mutation-types'
import Vue from 'vue'
import { IMapLayerState } from './state'
import { MutationTree } from 'vuex/types'
import { AloDbMapLayer, IAloDbMapLayerConstParam } from '@/models/alodb/AloDbMapLayer';
import glider from '@/api/glider';
import {i18n} from '@/locale/vueI18n'

/*
  Need to use export default({}) rather than export default {}
  ref links: https://github.com/TypeStrong/ts-loader/issues/588
*/
const mutations:MutationTree<IMapLayerState> = {
     
    //Gestion des recherches de missions
    [types.MAPLAYER_REQUEST]: state => {
        state.status = i18n.t('Admin.Loading',{item:i18n.t('Admin.MapLayer.Title').toString()}).toString()
        state.mapLayerLoading = true
    },
    [types.MAPLAYER_SUCCESS]: (state, mapLayers:Array<AloDbMapLayer>) => {
        state.status = i18n.t('Admin.LoadingOk',{item:i18n.t('Admin.MapLayer.Title').toString()}).toString()
        state.mapLayers = mapLayers   
        state.mapLayerLoading = false             
    },
    [types.MAPLAYER_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.MapLayer.Title').toString()}).toString()
        state.mapLayers = []
        state.mapLayerLoading = false
    },
    [types.MAPLAYER_SELECT_DETAIL_REQUEST]: (state, itemId:number) => {
        state.status = i18n.t('Admin.Loading',{item:`${i18n.t('Admin.MapLayer.Title').toString()} ${itemId}`}).toString()
        state.mapLayerLoading = true
    },
    [types.MAPLAYER_SELECT_DETAIL_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.MapLayer.Title').toString()}).toString()
        state.mapLayerLoading = false
    },
    [types.MAPLAYER_SELECT_DETAIL_SUCCESS]: (state,mapLayer:AloDbMapLayer) => {
        state.status = i18n.t('Admin.LoadingOk',{item:`${i18n.t('Admin.MapLayer.Title').toString()} ${mapLayer.LAY_ID}`}).toString()        
        //1, on met à jour de m'mapLayer dans la liste des mapLayers
        const index = state.mapLayers.findIndex(m => m.LAY_ID == mapLayer.LAY_ID)
        state.mapLayers.splice(index == -1 ? state.mapLayers.length : index, index == -1 ? 0 : 1, mapLayer)
        state.mapLayerLoading = false
    },
    [types.MAPLAYER_SELECT_DETAIL]: (state,mapLayer:AloDbMapLayer) => {                
        state.originalAdmMapLayer = mapLayer        
        state.modifiedAdmMapLayer = new AloDbMapLayer({...mapLayer} as IAloDbMapLayerConstParam )
    },
    [types.MAPLAYER_SAVE_REQUEST]: (state,libelle:string) => {
        state.status = i18n.t('Admin.SaveItem',{item:`${i18n.t('Admin.MapLayer.Title').toString()} ${libelle}`}).toString()
        state.mapLayerLoading = true
    },
    [types.MAPLAYER_SAVE_ERROR]: state => {
        state.status = i18n.t('Admin.ErrorSave',{item:i18n.t('Admin.MapLayer.Title').toString()}).toString()
        state.mapLayerLoading = false
    },
    [types.MAPLAYER_UPDATE_MODIFIED_ADM]: (state, newProperties:Object) => {        
        state.modifiedAdmMapLayer = {...state.modifiedAdmMapLayer,...newProperties}
    },
    [types.MAPLAYER_UPDATE_FILTER_ADM]: (state, newProperties:Object) => {        
        state.adminFilter = {...state.adminFilter,...newProperties}
    },
    [types.MAPLAYER_DELETE_REQUEST]: (state,libelle:string) => {
        state.status = i18n.t('Admin.DeleteItem',{item:`${i18n.t('Admin.MapLayer.Title').toString()} ${libelle}`}).toString()
        state.mapLayerLoading = true
    },
    [types.MAPLAYER_DELETE_SUCCESS]: (state,layerId:number) => {
        state.status = i18n.t('Admin.DeleteItemOk',{item:`${i18n.t('Admin.MapLayer.Title').toString()} ${layerId}`}).toString()
        const index = state.mapLayers.findIndex(l => l.LAY_ID == layerId)
        state.mapLayers.splice(index == -1 ? state.mapLayers.length : index, index == -1 ? 0 : 1)
        state.mapLayerLoading = false
    },
    [types.MAPLAYER_DELETE_ERROR]: state => {
        state.status = i18n.t('Admin.ErrorDelete',{item:i18n.t('Admin.MapLayer.Title').toString()}).toString()
        state.mapLayerLoading = false
    },
    [types.MAPLAYER_SET_GROUP_NAME_REQUEST]: state => {
        state.status = 'Rename mapLayers group'
        state.mapLayerLoading = true
    },
    [types.MAPLAYER_SET_GROUP_NAME_SUCCESS]: (state, mapLayers:Array<AloDbMapLayer>) => {
        state.status = 'success renaming mapLayers group'
        mapLayers.forEach(mapLayer => {            
            const index = state.mapLayers.findIndex(m => m.LAY_ID == mapLayer.LAY_ID)
            state.mapLayers.splice(index == -1 ? state.mapLayers.length : index, index == -1 ? 0 : 1, mapLayer)
        })        
        state.mapLayerLoading = false             
    },
    [types.MAPLAYER_SET_GROUP_NAME_ERROR]: state => {
        state.status = 'error renaming mapLayers group'
        state.mapLayers = []
        state.mapLayerLoading = false
    }    
}


export default mutations
